import { render, staticRenderFns } from "./required-documents-list.vue?vue&type=template&id=2b78c243&scoped=true"
import script from "./required-documents-list.vue?vue&type=script&lang=js"
export * from "./required-documents-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b78c243",
  null
  
)

export default component.exports